import { render, staticRenderFns } from "./ChoosePositionForAnalyze.vue?vue&type=template&id=1295b4a4&scoped=true&"
import script from "./ChoosePositionForAnalyze.vue?vue&type=script&lang=js&"
export * from "./ChoosePositionForAnalyze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1295b4a4",
  null
  
)

export default component.exports